// extracted by mini-css-extract-plugin
module.exports = {"tab":"IuqKNSKV","info":"fqcyC2i4"};